// extracted by mini-css-extract-plugin
export default {"messenger_container":"messenger_messenger_container__OysiH","messenger_container_active":"messenger_messenger_container_active__Io8fp"};